import { DEFORMER_MANIP_ENUM } from "../enums";
var BaseDeformer = /** @class */ (function () {
    function BaseDeformer() {
        this._deformerType = [DEFORMER_MANIP_ENUM.MATRIX];
        this._weights = [];
        this._dirty = true;
        this._enabled = true;
    }
    Object.defineProperty(BaseDeformer.prototype, "animatableProperties", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseDeformer.prototype, "enabled", {
        get: function () {
            return this._enabled;
        },
        set: function (value) {
            this._enabled = value;
            this._dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseDeformer.prototype, "dirty", {
        get: function () {
            // console.log(this.constructor.name, 'isDirty', this._dirty);
            return this._dirty;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseDeformer.prototype, "index", {
        // TODO: there can be a difference in index between the vertex and fragment shader
        get: function () {
            return this._deformerStack.deformerIndex(this) + 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseDeformer.prototype, "weights", {
        get: function () {
            return this._weights;
        },
        enumerable: false,
        configurable: true
    });
    BaseDeformer.prototype._generateWeights = function () {
    };
    Object.defineProperty(BaseDeformer.prototype, "stack", {
        get: function () {
            if (!this._deformerStack) {
                throw new Error('Deformer is not linked to a stack');
            }
            return this._deformerStack;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseDeformer.prototype, "parent", {
        /**
         * The parent object we're deforming
         */
        get: function () {
            return this.stack._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseDeformer.prototype, "deformerType", {
        get: function () {
            return this._deformerType;
        },
        enumerable: false,
        configurable: true
    });
    BaseDeformer.prototype._uniforms = function () {
        return {};
    };
    BaseDeformer.prototype._vertexHeader = function () {
        return '';
    };
    BaseDeformer.prototype._vertBody = function () {
        return '';
    };
    BaseDeformer.prototype._vertexMain = function () {
        return '';
    };
    BaseDeformer.prototype._fragmentHeader = function () {
        return '';
    };
    BaseDeformer.prototype._fragBody = function () {
        return '';
    };
    BaseDeformer.prototype.update = function () {
        if (!this._dirty) {
            return;
        }
        if (!this.canUpdate) {
            return;
        }
        this._updateProperties();
        this._dirty = false;
        this.emitDeformerChanged();
    };
    Object.defineProperty(BaseDeformer.prototype, "canUpdate", {
        /**
         * Returns true if the deformer can be updated. A deformer can be updated if it has a parent and that parent
         * has a geometry built.
         */
        get: function () {
            if (!this.parent) {
                return false;
            }
            if (!this.parent.geometry) {
                return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    BaseDeformer.prototype._updateProperties = function () {
        // pass
    };
    BaseDeformer.prototype.emitDeformerChanged = function () {
        // @ts-ignore
        this._deformerStack.emit('deformerChanged');
    };
    return BaseDeformer;
}());
export { BaseDeformer };
